import { type ReactNode } from 'react'

import { AnchorTarget } from '@/components/common/AnchorTarget'
import { cn } from '@/utils/commonUtil'

import styles from './Main.module.scss'

type Props = {
  children: ReactNode
  hasFilters?: boolean
}

export const Main = ({ children, hasFilters }: Props) => (
  <main className={cn(styles.container, { hasFilters, styles })}>
    <AnchorTarget id='main-content' />
    {children}
  </main>
)
